import { DatabaseProduct } from "../../Api/Database";
import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import config from "../../Api/config";
import { toast } from "react-toastify";


export interface ProductAccordionProps {
    item: any,
    //delete: () => Promise<boolean>
}

let serverUrl = window.location.origin;

export default function ItemAccordion(props: ProductAccordionProps) {

    const navigate = useNavigate();
    const unixMilliSeconds = props.item.created_at * 1000;
    const myDate = new Date(unixMilliSeconds);
    const notifyError = (err:any) => toast.error(err,{theme:"colored"});

    const handleChange = () => () => {
        //console.log("DETAILS pressed ");
      window.open(serverUrl+ "/item/" + props.item.id, "_blank");
    };

    const handleQrCode = () => () => {

        config.API.getDppQRCode(props.item.id).then((item) => {
           
            let blobUrl = window.URL.createObjectURL(item);
            let a = document.createElement('a');
            a.download = "Qr_code_"+props.item.id + ".png";
            a.href = blobUrl;
            document.body.appendChild(a);
            a.click();
            a.remove();

            // tuki se notr dela
        }).catch(error => {
            console.error("Error in API for product: ", error);
            notifyError("Error: " + error);
        });
    };

    useEffect(() => {
        //console.log(props.item);
    }, [])

    return (
        <div className="dpp_card_element">
            <img className="clickable-item" src={props.item.thumbnail} alt="product-variant" height="60px" width="60px"  onClick={handleChange()} />
            <p className="dpp_card_title">{props.item.variant_name}</p>
            <p className="dpp_card_product">Prod.: {props.item.parent_name}</p>
            <p className="dpp_card_id">ID: {props.item.id}</p>
            <p className="dpp_card_date">Date: {myDate.toLocaleString()}</p>

            <button onClick={handleQrCode()}>QR code</button>
            <button onClick={handleChange()}>More details</button>
        </div>
    )
}
